<template>
  <NavMainBarCategory
    :current-item="onSaleCategory"
    :bold="true"
    color="text-EXPONDO-red"
  />
</template>

<script lang="ts">

import { createOnSaleLink } from '~~/helpers/navigation/createNavLinks';
import type { NavBarCategory } from '~~/types/category/NavBarCategory';

export default defineComponent({
  name: 'NavMainBarOnSale',

  setup() {

    const i18n = useI18n();

    const onSaleLink = createOnSaleLink();
    const onSaleCategory: NavBarCategory = {
      name: i18n.t('on-sale'),
      link: onSaleLink,
    };

    return {
      onSaleCategory,
    };
  
  },
});

</script>
